/**
 * Created by Shen Mo on 2018/7/20
 */
import * as _ from 'lodash-es';

import { filterParams } from './htmlFilter';
import isUrl from './isUrl';

export const parseQuery = (str) => {
	let ret = {},
		seg = str.replace(/^\?/, '').split('&'),
		len = seg.length,
		i = 0,
		s;
	for (; i < len; i++) {
		if (!seg[i]) {
			continue;
		}
		s = seg[i].split('=');
		ret[s[0]] = filterParams(decodeURIComponent(s[1]));
	}
	return ret;
};

export const parseUrl = (url) => {
	const a = document.createElement('a');
	a.href = url;
	return {
		source: url,
		protocol: a.protocol.replace(':', ''),
		host: a.hostname,
		port: a.port,
		query: a.search,
		params: parseQuery(a.search),
		file: (a.pathname.match(/\/([^\/?#]+)$/i) || ['', ''])[1],
		hash: a.hash.replace('#', ''),
		pathname: a.pathname,
		path: a.pathname.replace(/^([^\/])/, '/$1'),
		relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || ['', ''])[1],
		segments: a.pathname.replace(/^\//, '').split('/'),
	};
};

// 格式化链接 去除非法链接
export const linkify = (str) => {
	// 判断类型, 进行跳转
	let link = _.trim(str || '');
	let linkParseUrl = parseUrl(link);
	const currentLink = parseUrl(location.href);
	if (linkParseUrl.protocol && link.indexOf(linkParseUrl.host) !== -1) {
		// is link?
		if (currentLink.host === linkParseUrl.host && currentLink.pathname === linkParseUrl.pathname) {
			// 同域名下的相同路径
			link = null;
		}
	} else if (isUrl(link)) {
		if (!link.match(/^(http:\/\/|https:\/\/)/)) {
			link = 'http://' + link;
		}
	} else {
		// 非判断为链接的时候 ---> 清空
		link = null;
	}
	return link;
};

export const addUrlParams = (url, params) => {
	let _paramsStr = '';
	let _url = url;
	_.forEach(params, (d, k) => {
		if (!d) {
			return true;
		}
		const _pStr = `${k}=${encodeURIComponent(decodeURIComponent(d))}`;
		if (_url.indexOf(`${k}=`) > -1) {
			_url = _url.replace(new RegExp(`(&|\\?)${k}.+?(&|$)`), ($, $1, $2) => {
				// 确保获取的数据是正确的params
				return `${$1}${_pStr}${$2}`;
			});
		} else {
			if (_paramsStr) {
				_paramsStr += '&';
			}
			_paramsStr += _pStr;
		}
	});
	if (!_paramsStr) {
		return _url;
	} else if (_url.indexOf('?') > -1) {
		let urlArr = _url.split('?');
		if (urlArr[1]) {
			return urlArr[0] + '?' + _paramsStr + '&' + urlArr[1];
		} else {
			return urlArr[0] + '?' + _paramsStr;
		}
	} else {
		if (_url.indexOf('#') > -1) {
			return _url.split('#')[0] + '?' + _paramsStr + location.hash;
		} else {
			return _url + '?' + _paramsStr;
		}
	}
};

// 链接拼接 将 https://example.com/test 和 /xxx/12313 拼接成 ==>  https://example.com/xxx/12313
// 将 https://example.com/test 和 ./xxx/12313 拼接成 ==>  https://example.com/test/xxx/12313
// 将 https://example.com/test 和 ../xxx/12313 拼接成 ==>  https://example.com/xxx/12313

export const linkJoin = (url, link) => {
	if (!url) {
		return link;
	}
	if (!link) {
		return url;
	}

	if (link.indexOf('http') === 0) {
		return link;
	}
	const formatUrl = linkify(url);
	if (!formatUrl) {
		return link;
	}

	const urlParse = parseUrl(formatUrl);
	const urlBase = `${urlParse.protocol}://${urlParse.host}${urlParse.port ? `:${urlParse.port}` : ''}`;
	if (link.indexOf('/') === 0) {
		return `${urlBase}${link}`;
	} else if (link.indexOf('./') === 0) {
		return `${urlBase}${urlParse.path}/${link.replace('./', '')}`;
	} else if (link.indexOf('../') === 0) {
		let _link = link;
		let _url = urlParse.path;
		while (_link.indexOf('../') === 0) {
			_link = _link.replace('../', '');
			_url = _url.replace(/\/[^\/]+\/?$/, '');
		}
		return `${urlBase}${_url}/${_link}`;
	}
	return `${urlBase}/${link}`;
};
